import { WHY } from '../../content/site';
import m from '../../styles/marketing.module.css';
import styles from './Sections.module.css';

/** Why us: the page's one kinetic chapter word, a pull statement, then three
 *  pillars on hairlines. */
const Why = () => (
  <section className={`${m.section} ${m.navy} ${m.onNavy}`} id="why">
    <div className={m.container}>
      <h2 className={`${m.kinetic} ${m.kineticLight}`} data-scrub="left">
        why <span>us.</span>
      </h2>
      <div className={styles.whyHead} data-reveal>
        <p className={styles.whyStatement}>{WHY.statement}</p>
        <p className={styles.whyLead}>{WHY.lead}</p>
      </div>
      <div className={styles.pillars}>
        {WHY.pillars.map((pillar, i) => (
          <article key={pillar.title} className={styles.pillar} data-reveal data-reveal-delay={i * 90}>
            <h3>{pillar.title}</h3>
            <p>{pillar.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Why;
